// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/reimo-avatar.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/NewsGot-Reg.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/NewsGot-Reg.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/NewsGot-Dem.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/fonts/NewsGot-Dem.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}
.imgHotspot > div > img {
	width: 1024px !important;
	height: 633px !important;
	border-radius: 10px;
}

div:has(> .blobX) {
	background: none !important;
	box-shadow: none !important;
	
}

.blobX:has(> div) {
	background: none !important;
	box-shadow: none !important;
	
}

.react-chatbot-kit-chat-bot-avatar-letter {
  display: none;
}

.react-chatbot-kit-chat-bot-avatar-container {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: auto;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #fec700 !important;
}

input.react-chatbot-kit-chat-input::placeholder {
  color: #888;
  font-style: italic;
  content: "Deine Nachricht hier eingeben"; /* funktioniert nur visuell */
}

.react-chatbot-kit-chat-bot-message span {
  white-space: pre-wrap;
}

.MuiDataGrid-root {
	border: none !important;
}

.blobX {
	background: green;
	border-radius: 50%;
	margin: 10px;
	height: 20px;
	width: 20px;

	box-shadow: 0 0 0 0 rgba(0, 128, 0, 1);
	transform: scale(1);
	animation: pulseX 3s infinite;
}

.thumbnailPdf > div > div > canvas {
	width: 35px !important;
	height: 50px !important;
}

@keyframes pulseX {
	0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(0, 128, 0, 0.7);
	}

	70% {
		transform: scale(1);
		box-shadow: 0 0 0 10px rgba(0, 128, 0, 0);
	}

	100% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(0, 128, 0, 0);
	}
}

@keyframes pulse-ring {
  0% {
    transform: scale(.33);
  }
  80%, 100% {
    opacity: 0;
  }
}

@keyframes pulse-dot {
  0% {
    transform: scale(.8);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(.8);
  }
}
@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}


@keyframes uparrow {
  0% { -webkit-transform: translateY(0); opacity: 0.4 }
  100% { -webkit-transform: translateY(-0.4em); opacity: 0.9 }
}
@keyframes downarrow {
  0% { -webkit-transform: translateY(0); opacity: 0.4 }
  100% { -webkit-transform: translateY(0.4em); opacity: 0.9 }
}

.stickyConfigurationSumUp {
    width: 100%;
    position: sticky;
    position: -webkit-sticky;
    top: 100px;
    font-size: 1.2em;
    font-weight: 400;
}

.containerX {
  background-image: url('http://www.placekitten.com/g/1000/1000');
  position:absolute;
}
.arrowX {
  border-color:transparent;
  border-style:solid;
  border-width:0 2em;
  display:block;
  height:0;
  margin:10em auto;
  opacity:0.4;
  text-indent:-9999px;
  transform-origin: 50% 50%;
  width:0;
}

.upX {
  animation: uparrow 0.6s infinite alternate ease-in-out;
  -webkit-animation: uparrow 0.6s infinite alternate ease-in-out;
  border-bottom:2em solid #00b6f1;
}
.downX {
  animation: downarrow 0.6s infinite alternate ease-in-out;
  -webkit-animation: downarrow 0.6s infinite alternate ease-in-out;
  border-top:2em solid #00b6f1;
}

.kaufberatungFliess {
	font-size: 18px;
}

section {
	padding: 3em 5%;
}

.socialIcon {
	width: 32px;
	height: 32px;
}

.ps-block--vendor-milestone {
    display: flex;
    flex-flow: row nowrap;
    position: relative;
    padding-bottom: 90px;
}

.ps-block--vendor-milestone .ps-block__left {
    padding-right: 140px;
}

.ps-block--vendor-milestone .ps-block__left, .ps-block--vendor-milestone .ps-block__right {
    width: 100%;
}

.ps-block--vendor-milestone .ps-block__right {
    text-align: right;
}

.ps-block--vendor-milestone .ps-block__left, .ps-block--vendor-milestone .ps-block__right {
    width: 100%;
}
.ps-block--vendor-milestone.reverse .ps-block__left {
    padding-left: 140px;
    padding-right: 0;
}

.ps-block__number {
	font-size: 32px;
}	

.ps-block--vendor-milestone .ps-block__number {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 100px;
    background-color: #fff;
    border: 2px solid #fcb800;
    border-radius: 50%;
}

.ps-block--vendor-milestone.reverse {
    flex-flow: row-reverse nowrap;
}

.ps-block--vendor-milestone:before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 100%;
    width: 2px;
    background-color: #fcb800;
}


.modelhero .box-container {
    display: flex;
    flex-wrap: wrap;
    min-height: 250px;
    position: relative;
    overflow: hidden;
}

.modelhero img {
    height: 250px;
    object-fit: cover;
    width: 100%;
}

.headlineNewPoint {
	font-family: 'NewsGothicBold';
	font-size: 2em;
}

.sloganNewPoint {
	font-family: 'NewsGothic';
	font-size: 1.5em;
}

.altFliessText {
	font-family: 'NewsGothic';
	font-size: 1.3em;
	color: rgba(0,0,0,0.6);

}


.quote-wrapper {
  height: 600px;
  position: relative;
  width: 600px;
}

.stdContent {
	font-family: 'NewsGothic';
	font-size: 1.1em;
	hyphens: auto; 
	text-align: justify;
}

 .textNewsletter {
  background: radial-gradient(
    ellipse at center,
    rgba(0, 181, 185, 1) 0%,
    rgba(0, 181, 185, 1) 70%,
    rgba(0, 181, 185, 0) 70.3%
  );
  height: 100%;
  width: 100%;
}
.textNewsletter {
  color: white;
  position: relative;
  margin: 0;
}

.textNewsletter p {
  height: 100%;
  line-height: 1.25;
  padding: 0;
  text-align: center;
  text-shadow: 0.5px 0.5px 1px rgba(0, 0, 0, 0.3);
}

.textNewsletter::before {
  content: "";
  float: left;
  height: 100%;
  width: 50%;
  shape-outside: polygon(
    0 0,
    98% 0,
    50% 6%,
    23.4% 17.3%,
    6% 32.6%,
    0 50%,
    6% 65.6%,
    23.4% 82.7%,
    50% 94%,
    98% 100%,
    0 100%
  );
  shape-margin: 3%;
}

.textNewsletter p::before {
  content: "";
  float: right;
  height: 100%;
  width: 50%;
  shape-outside: polygon(
    2% 0%,
    100% 0%,
    100% 100%,
    2% 100%,
    50% 94%,
    76.6% 82.7%,
    94% 65.6%,
    100% 50%,
    94% 32.6%,
    76.6% 17.3%,
    50% 6%
    );
  shape-margin: 3%;
}



.modelhero .content {
    align-items: center;
    background-color: rgba(220,220,220,.8);
    clip-path: polygon(42% 0,100% 0,100% 100%,28% 100%);
    display: flex;
    height: 100%;
    justify-content: flex-start;
    max-width: 40rem;
    padding: 2rem 4rem 2rem 15rem;
    position: absolute;
    right: 0;
    top: 0;
}

.modelhero .heading {
    -webkit-box-align: start;
    -ms-flex-align: start;
    -ms-grid-row-align: flex-start;
    align-items: flex-start;
    padding-bottom: 0;
}

.modelhero .content h3 {
    color: var(--white);
    line-height: 1.3;
    padding-bottom: 1rem;
}

.modelhero .content p {
    color: var(--white);
    letter-spacing: .5px;
    line-height: 1.6;
    padding-bottom: 2rem;
}

.modelhero .btn {
    border: 0.15rem solid var(--white);
}


.MuiFormLabel-root {
	font-size: 18px;
}





.about .box-container {
    display: flex;
    flex-wrap: wrap;
    min-height: 80vh;
    position: relative;
    overflow: hidden;
}

.about img {
    height: 80vh;
    object-fit: cover;
    width: 100%;
}


.about .content {
    align-items: center;
    background-color: rgba(220,220,220,.8);
    clip-path: polygon(42% 0,100% 0,100% 100%,28% 100%);
    display: flex;
    height: 100%;
    justify-content: flex-start;
    max-width: 40rem;
    padding: 2rem 4rem 2rem 15rem;
    position: absolute;
    right: 0;
    top: 0;
}

.about .heading {
    -webkit-box-align: start;
    -ms-flex-align: start;
    -ms-grid-row-align: flex-start;
    align-items: flex-start;
    padding-bottom: 0;
}

.about .content h3 {
    color: var(--white);
    line-height: 1.3;
    padding-bottom: 1rem;
}

.about .content p {
    color: var(--white);
    letter-spacing: .5px;
    line-height: 1.6;
    padding-bottom: 2rem;
}

.about .btn {
    border: 0.15rem solid var(--white);
}



.btn {
    background: var(--main-color);
    box-shadow: var(--box-shadow);
    color: var(--white);
    display: inline-block;
    font-size: 1.8rem;
    font-weight: 500;
    letter-spacing: .1rem;
    padding: 1rem 2.5rem;
    transition: all .5s ease-in-out;
}

.galleryImg {
    height:150px;
    width:100%;
 }
 
.galleryImgZoom {
    animation:move 22s infinite ease-in-out;
 }

@keyframes move{
0%{
 transform: scale(1) rotate(0deg);
}
  100%{
   transform: scale(1.2) rotate(0.1deg);

  }

}

/* Slow-motion Zoom Container */
.img-hover-zoom--slowmo img {
  transform-origin: 50% 65%;
  transition: transform 1s, filter 1s ease-in-out;
}

/* The Transformation */
.img-hover-zoom--slowmo:hover img {
  transform: scale(1.1);
}

.hover14 figure {
	position: relative;
}
.hover14 figure::before {
	position: absolute;
	top: 0;
	left: -75%;
	z-index: 2;
	display: block;
	content: '';
	width: 50%;
	height: 100%;
	background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,.3) 100%);
	transform: skewX(-25deg);
}
.hover14 figure:hover::before {
	animation: shine .75s;
}
@keyframes shine {
	100% {
		left: 125%;
	}
}


figure {
	margin: 0;
}

.MuiTabs-vertical {
	min-width: 200px;
}

h1,h2,h3,h4,h5,h6, a {
	color: rgba(0,0,0,0.6);
	font-weight: 400;
	
}

/* Zoom In #1 */
.hover01 figure img {
	transform: scale(1);
	transition: .3s ease-in-out;
}
.hover01 figure:hover img {
	transform: scale(1.3);
}

/* Zoom In #2 */
.hover02 figure img {
	width: 300px;
	height: auto;
	transition: .3s ease-in-out;
}
.hover02 figure:hover img {
	width: 350px;
}

/* Zoom Out #1 */
.hover03 figure img {
	transform: scale(1.5);
	transition: .3s ease-in-out;
}
.hover03 figure:hover img {
	transform: scale(1);
}

/* Zoom Out #2 */
.hover04 figure img {
	width: 400px;
	height: auto;
	transition: .3s ease-in-out;
}
.hover04 figure:hover img {
	width: 300px;
}

/* Slide */
.hover05 figure img {
	margin-left: 30px;
	transform: scale(1.5);
	transition: .3s ease-in-out;
}
.hover05 figure:hover img {
	margin-left: 0;
}
@keyframes flash {
	0% {
		opacity: .4;
	}
	100% {
		opacity: 1;
	}
}

.backgroundColor1 {
	background: linear-gradient(135deg, rgba(91, 228, 155, 0.2), rgba(0, 167, 111, 0.2)) rgb(255, 255, 255);	
	min-height: 200px;
}

.backgroundColor2 {
	background: linear-gradient(135deg, rgba(97, 243, 243, 0.2), rgba(0, 184, 217, 0.2)) rgb(255, 255, 255);	
	min-height: 200px;
}

.backgroundColor3 {
	background: linear-gradient(135deg, rgba(255, 214, 102, 0.2), rgba(255, 171, 0, 0.2)) rgb(255, 255, 255);	
	min-height: 200px;
}

.backgroundColor3a {
	background: linear-gradient(135deg, rgba(255, 214, 102, 0.2), rgba(255, 171, 0, 0.2)) rgb(255, 255, 255);	
	max-height: 30px;
}

.bgIcon {
    width: 112px;
    height: 112px;
    right: -32px;
    opacity: 0.08;
	margin-right: -25px;
}


.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.swiper-pagination {
	margin-top: 10px;	
	padding-bottom: 5px;	
}

.swiper-pagination-bullet {
  width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 12px));
  height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 12px));
  display: inline-block;
  border-radius: var(--swiper-pagination-bullet-border-radius, 50%);
  background: var(--swiper-pagination-bullet-inactive-color, #000);
  opacity: var(--swiper-pagination-bullet-inactive-opacity, 0.2);
  font-size: 12px;
  color: white;
}

.centerImage {
  border: 1px solid;
  margin: auto;
  width: 75%;
  padding: 10px;
}

.bottomRight {
    position: fixed;
    bottom: 0;
    right: 0;
}


.MuiStepLabel-label {
	font-size: 16px !important;
}

.leftSpacing {
	margin-left: 20px;	
}

.spacerHeader {	
	width: 100%;
	margin-bottom: 40px;
  	height: 1px;
	background: linear-gradient(90deg, rgba(255,255,255,.5) 0%, rgba(100,100,100,.5) 50%, rgba(255,255,255,.5) 100%);
}

.spacer {	
	width: 90%;
	margin-top: 40px;
  	height: 1px;
	background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(100,100,100,.5) 50%, rgba(255,255,255,1) 100%);
}


 
 

.swiper-horizontal {
	border-top: 0px solid #ddd;	
	padding-top: 15px;
}

.swiper-pagination {
	border-bottom: none;	
}

.centerCarCard {
    width: 345px; 
    height: auto;
    margin: 0 auto;
    padding: 10px;
    position: relative;
}

.displayHeight {
    width: 305px; 
	height: auto;
    margin: 0 auto;
    padding: 10px;
    position: relative;
}

.smallHeader .smallHeader-image {
  display: block;
  visibility: hidden;
  height: auto;
  width: 100%;
 }
 
.pulse:hover, 
.pulse:focus {
  animation: pulse 1s;
  box-shadow: 0 0 0 2em transparent;
}

@keyframes pulse {
  0% { box-shadow: 0 0 0 0 var(--hover); }
}
 
 


.heroAdvice1 {
	position: absolute;
	left: 0px;
	right: 0px;
	z-index: 1000;
	text-align: center;
	border-radius: 5px;
  display: grid;
  justify-content: center;
  align-items: center;	
}

.heroAdvice {
	position: absolute;
	margin-top: 20px;
	margin-left: 0px;
	width: 100%;
	z-index: 1000;
}

.heroHeadline {
	color: #fff;
	font-weight: 1000;  
	font-size: 3em;
}

.heroSlogan {
	color: #fff;
	font-weight: 800;  
	font-size: 1.5em;
}

.slide-container .content {
    align-items: center;
    background: linear-gradient(rgba(0,0,0,.7),rgba(0,0,0,.3));
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    padding: 8rem 7% 2rem;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 100;
}

.slide-container .content .text {
    text-align: center;
    width: 80rem;
}
 
.container img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.txtLeft {
	text-align: left;	
	
}

ul.empty {
    list-style-type: none;
	margin: 0;  
    padding: 0; 
    margin-top: 20px;
}  

ul.empty > li > svg {
	margin-right: 5px;
}

ul.empty2 {
    list-style-type: none;
	margin: 0;  
    padding: 0; 
    margin-top: 0px;
    padding-bottom: 8px;
}  

ul.empty2 > li > svg {
	margin-right: 5px;
}

ul.empty2 > li {
	display: inline-flex;
    list-style-type: none;
	margin: 0;  
    padding: 0; 
    margin-top: 0px;
}  

ul.empty > li {
	display: flex;
    list-style-type: none;
	margin: 0;  
    padding: 0; 
    margin-top: 5px;
}  

ul.empty2 > li {
    margin-top: 0 !important;
}  
  
.nav ul {
    list-style: none;
}

.nav li {
    display: inline-block !important;
    padding: 0;
    vertical-align: middle;
}


.headlineCompare {
	margin: 0px;
	margin-bottom: 4px;
}

.swiper-button-prev {
	color: #dc0000;
}

.swiper-button-next {
	color: #dc0000;
}

.swiperTopBottom > div  > .swiper-button-prev {
	left: 50% !important;
    top: 0 !important;
    transform: rotate(90deg);
    transform-origin: left center;
}

.swiperTopBottom > div > .swiper-button-next {
 	left: 50% !important;
   	bottom: 20px !important;
	position: sticky;
    transform: rotate(90deg);
    transform-origin: left center;
}


.check .leftSpace {
	margin-left: 0px;
}

.textOutline {
	  -webkit-text-stroke-width: 4px;
  -webkit-text-stroke-color: red;
}

a {
	cursor: pointer;
}

body {
	font-family:'NewsGothic'
}

@font-face {
    font-family: 'NewsGothic';
    font-style: normal;
    font-weight: 400; /* Standard/Regular */
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
    font-display: swap; /* Verhindert das "Verschwinden" des Textes beim Laden */
}

/* News Gothic - Demi-Bold (wird als Bold genutzt) */
@font-face {
    font-family: 'NewsGothicBold';
    font-style: normal;
    font-weight: 700; /* Bold-Äquivalent */
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('opentype');
    font-display: swap;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;CACC,wBAAwB;CACxB,wBAAwB;CACxB,mBAAmB;AACpB;;AAEA;CACC,2BAA2B;CAC3B,2BAA2B;;AAE5B;;AAEA;CACC,2BAA2B;CAC3B,2BAA2B;;AAE5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yDAAwD;EACxD,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wCAAwC,EAAE,6BAA6B;AACzE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,WAAW;;CAEX,sCAAsC;CACtC,mBAAmB;CACnB,6BAA6B;AAC9B;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA;CACC;EACC,sBAAsB;EACtB,wCAAwC;CACzC;;CAEA;EACC,mBAAmB;EACnB,yCAAyC;CAC1C;;CAEA;EACC,sBAAsB;EACtB,sCAAsC;CACvC;AACD;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,4CAA4C;EAC9C;AACF;;;AAGA;EACE,KAAK,gCAAgC,EAAE,aAAa;EACpD,OAAO,qCAAqC,EAAE,aAAa;AAC7D;AACA;EACE,KAAK,gCAAgC,EAAE,aAAa;EACpD,OAAO,oCAAoC,EAAE,aAAa;AAC5D;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,wBAAwB;IACxB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;EACE,+DAA+D;EAC/D,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,OAAO;AACT;;AAEA;EACE,sDAAsD;EACtD,8DAA8D;EAC9D,+BAA+B;AACjC;AACA;EACE,wDAAwD;EACxD,gEAAgE;EAChE,4BAA4B;AAC9B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,MAAM;IACN,SAAS;IAET,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IAET,2BAA2B;IAC3B,YAAY;IACZ,UAAU;IACV,yBAAyB;AAC7B;;;AAGA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,WAAW;AACf;;AAEA;CACC,6BAA6B;CAC7B,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,sBAAsB;;AAEvB;;;AAGA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,aAAa;CACb,mBAAmB;AACpB;;CAEC;EACC;;;;;GAKC;EACD,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV;;;;;;;;;;;;GAYC;EACD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;EACV;;;;;;;;;;;;KAYG;EACH,gBAAgB;AAClB;;;;AAIA;IACI,mBAAmB;IACnB,sCAAsC;IAEtC,mDAAmD;IACnD,aAAa;IACb,YAAY;IACZ,2BAA2B;IAC3B,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,8BAA8B;IAC9B,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;AACtC;;;AAGA;CACC,eAAe;AAChB;;;;;;AAMA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,WAAW;AACf;;;AAGA;IACI,mBAAmB;IACnB,sCAAsC;IAEtC,mDAAmD;IACnD,aAAa;IACb,YAAY;IACZ,2BAA2B;IAC3B,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,8BAA8B;IAC9B,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;AACtC;;;;AAIA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;IACpB,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,UAAU;CACb;;AAED;IACI,uCAAuC;CAC1C;;AAED;AACA;CACC,gCAAgC;AACjC;EACE;GACC,oCAAoC;;EAErC;;AAEF;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;AACvB;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,UAAU;CACV,UAAU;CACV,cAAc;CACd,WAAW;CACX,UAAU;CACV,YAAY;CAEZ,wFAAwF;CAExF,wBAAwB;AACzB;AACA;CAEC,qBAAqB;AACtB;AAMA;CACC;EACC,UAAU;CACX;AACD;;;AAGA;CACC,SAAS;AACV;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;;AAEjB;;AAEA,eAAe;AACf;CAEC,mBAAmB;CAEnB,2BAA2B;AAC5B;AACA;CAEC,qBAAqB;AACtB;;AAEA,eAAe;AACf;CACC,YAAY;CACZ,YAAY;CAEZ,2BAA2B;AAC5B;AACA;CACC,YAAY;AACb;;AAEA,gBAAgB;AAChB;CAEC,qBAAqB;CAErB,2BAA2B;AAC5B;AACA;CAEC,mBAAmB;AACpB;;AAEA,gBAAgB;AAChB;CACC,YAAY;CACZ,YAAY;CAEZ,2BAA2B;AAC5B;AACA;CACC,YAAY;AACb;;AAEA,UAAU;AACV;CACC,iBAAiB;CAEjB,qBAAqB;CAErB,2BAA2B;AAC5B;AACA;CACC,cAAc;AACf;AAUA;CACC;EACC,WAAW;CACZ;CACA;EACC,UAAU;CACX;AACD;;AAEA;CACC,uGAAuG;CACvG,iBAAiB;AAClB;;AAEA;CACC,uGAAuG;CACvG,iBAAiB;AAClB;;AAEA;CACC,wGAAwG;CACxG,iBAAiB;AAClB;;AAEA;CACC,wGAAwG;CACxG,gBAAgB;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,aAAa;CAChB,mBAAmB;AACpB;;;AAGA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;EACE,wFAAwF;EACxF,0FAA0F;EAC1F,qBAAqB;EACrB,iEAAiE;EACjE,gEAAgE;EAChE,8DAA8D;EAC9D,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,aAAa;AACf;;AAEA;IACI,eAAe;IACf,SAAS;IACT,QAAQ;AACZ;;;AAGA;CACC,0BAA0B;AAC3B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,mBAAmB;GACjB,WAAW;CACb,gHAAgH;AACjH;;AAEA;CACC,UAAU;CACV,gBAAgB;GACd,WAAW;CACb,8GAA8G;AAC/G;;;;;;AAMA;CACC,0BAA0B;CAC1B,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;CACf,YAAY;IACT,cAAc;IACd,aAAa;IACb,kBAAkB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,WAAW;CACZ;;AAED;;EAEE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,KAAK,gCAAgC,EAAE;AACzC;;;;;AAKA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,aAAa;CACb,kBAAkB;CAClB,kBAAkB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,WAAW;CACX,aAAa;AACd;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;IACI,mBAAmB;IACnB,0DAA0D;IAC1D,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,OAAO;IACP,qBAAqB;IACrB,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;CACC,gBAAgB;;AAEjB;;AAEA;IACI,qBAAqB;CACxB,SAAS;IACN,UAAU;IACV,gBAAgB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;IACI,qBAAqB;CACxB,SAAS;IACN,UAAU;IACV,eAAe;IACf,mBAAmB;AACvB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,oBAAoB;IACjB,qBAAqB;CACxB,SAAS;IACN,UAAU;IACV,eAAe;AACnB;;AAEA;CACC,aAAa;IACV,qBAAqB;CACxB,SAAS;IACN,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,UAAU;IACV,sBAAsB;AAC1B;;;AAGA;CACC,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,oBAAoB;IACjB,iBAAiB;IACjB,wBAAwB;IACxB,6BAA6B;AACjC;;AAEA;EACE,oBAAoB;IAClB,uBAAuB;CAC1B,gBAAgB;IACb,wBAAwB;IACxB,6BAA6B;AACjC;;;AAGA;CACC,gBAAgB;AACjB;;AAEA;GACG,8BAA8B;EAC/B,8BAA8B;AAChC;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC;AACD;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB,EAAE,qBAAqB;IACvC;mEAC2D;IAC3D,kBAAkB,EAAE,wDAAwD;AAChF;;AAEA,oDAAoD;AACpD;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB,EAAE,oBAAoB;IACtC;mEAC2D;IAC3D,kBAAkB;AACtB","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n.imgHotspot > div > img {\n\twidth: 1024px !important;\n\theight: 633px !important;\n\tborder-radius: 10px;\n}\n\ndiv:has(> .blobX) {\n\tbackground: none !important;\n\tbox-shadow: none !important;\n\t\n}\n\n.blobX:has(> div) {\n\tbackground: none !important;\n\tbox-shadow: none !important;\n\t\n}\n\n.react-chatbot-kit-chat-bot-avatar-letter {\n  display: none;\n}\n\n.react-chatbot-kit-chat-bot-avatar-container {\n  background-image: url('/public/assets/reimo-avatar.png');\n  background-size: auto;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: #fec700 !important;\n}\n\ninput.react-chatbot-kit-chat-input::placeholder {\n  color: #888;\n  font-style: italic;\n  content: \"Deine Nachricht hier eingeben\"; /* funktioniert nur visuell */\n}\n\n.react-chatbot-kit-chat-bot-message span {\n  white-space: pre-wrap;\n}\n\n.MuiDataGrid-root {\n\tborder: none !important;\n}\n\n.blobX {\n\tbackground: green;\n\tborder-radius: 50%;\n\tmargin: 10px;\n\theight: 20px;\n\twidth: 20px;\n\n\tbox-shadow: 0 0 0 0 rgba(0, 128, 0, 1);\n\ttransform: scale(1);\n\tanimation: pulseX 3s infinite;\n}\n\n.thumbnailPdf > div > div > canvas {\n\twidth: 35px !important;\n\theight: 50px !important;\n}\n\n@keyframes pulseX {\n\t0% {\n\t\ttransform: scale(0.95);\n\t\tbox-shadow: 0 0 0 0 rgba(0, 128, 0, 0.7);\n\t}\n\n\t70% {\n\t\ttransform: scale(1);\n\t\tbox-shadow: 0 0 0 10px rgba(0, 128, 0, 0);\n\t}\n\n\t100% {\n\t\ttransform: scale(0.95);\n\t\tbox-shadow: 0 0 0 0 rgba(0, 128, 0, 0);\n\t}\n}\n\n@keyframes pulse-ring {\n  0% {\n    transform: scale(.33);\n  }\n  80%, 100% {\n    opacity: 0;\n  }\n}\n\n@keyframes pulse-dot {\n  0% {\n    transform: scale(.8);\n  }\n  50% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(.8);\n  }\n}\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n\n@keyframes uparrow {\n  0% { -webkit-transform: translateY(0); opacity: 0.4 }\n  100% { -webkit-transform: translateY(-0.4em); opacity: 0.9 }\n}\n@keyframes downarrow {\n  0% { -webkit-transform: translateY(0); opacity: 0.4 }\n  100% { -webkit-transform: translateY(0.4em); opacity: 0.9 }\n}\n\n.stickyConfigurationSumUp {\n    width: 100%;\n    position: sticky;\n    position: -webkit-sticky;\n    top: 100px;\n    font-size: 1.2em;\n    font-weight: 400;\n}\n\n.containerX {\n  background-image: url('http://www.placekitten.com/g/1000/1000');\n  position:absolute;\n}\n.arrowX {\n  border-color:transparent;\n  border-style:solid;\n  border-width:0 2em;\n  display:block;\n  height:0;\n  margin:10em auto;\n  opacity:0.4;\n  text-indent:-9999px;\n  transform-origin: 50% 50%;\n  width:0;\n}\n\n.upX {\n  animation: uparrow 0.6s infinite alternate ease-in-out;\n  -webkit-animation: uparrow 0.6s infinite alternate ease-in-out;\n  border-bottom:2em solid #00b6f1;\n}\n.downX {\n  animation: downarrow 0.6s infinite alternate ease-in-out;\n  -webkit-animation: downarrow 0.6s infinite alternate ease-in-out;\n  border-top:2em solid #00b6f1;\n}\n\n.kaufberatungFliess {\n\tfont-size: 18px;\n}\n\nsection {\n\tpadding: 3em 5%;\n}\n\n.socialIcon {\n\twidth: 32px;\n\theight: 32px;\n}\n\n.ps-block--vendor-milestone {\n    display: flex;\n    flex-flow: row nowrap;\n    position: relative;\n    padding-bottom: 90px;\n}\n\n.ps-block--vendor-milestone .ps-block__left {\n    padding-right: 140px;\n}\n\n.ps-block--vendor-milestone .ps-block__left, .ps-block--vendor-milestone .ps-block__right {\n    width: 100%;\n}\n\n.ps-block--vendor-milestone .ps-block__right {\n    text-align: right;\n}\n\n.ps-block--vendor-milestone .ps-block__left, .ps-block--vendor-milestone .ps-block__right {\n    width: 100%;\n}\n.ps-block--vendor-milestone.reverse .ps-block__left {\n    padding-left: 140px;\n    padding-right: 0;\n}\n\n.ps-block__number {\n\tfont-size: 32px;\n}\t\n\n.ps-block--vendor-milestone .ps-block__number {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 0;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n    transform: translateX(-50%);\n    width: 100px;\n    height: 100px;\n    background-color: #fff;\n    border: 2px solid #fcb800;\n    border-radius: 50%;\n}\n\n.ps-block--vendor-milestone.reverse {\n    flex-flow: row-reverse nowrap;\n}\n\n.ps-block--vendor-milestone:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n    transform: translateX(-50%);\n    height: 100%;\n    width: 2px;\n    background-color: #fcb800;\n}\n\n\n.modelhero .box-container {\n    display: flex;\n    flex-wrap: wrap;\n    min-height: 250px;\n    position: relative;\n    overflow: hidden;\n}\n\n.modelhero img {\n    height: 250px;\n    object-fit: cover;\n    width: 100%;\n}\n\n.headlineNewPoint {\n\tfont-family: 'NewsGothicBold';\n\tfont-size: 2em;\n}\n\n.sloganNewPoint {\n\tfont-family: 'NewsGothic';\n\tfont-size: 1.5em;\n}\n\n.altFliessText {\n\tfont-family: 'NewsGothic';\n\tfont-size: 1.3em;\n\tcolor: rgba(0,0,0,0.6);\n\n}\n\n\n.quote-wrapper {\n  height: 600px;\n  position: relative;\n  width: 600px;\n}\n\n.stdContent {\n\tfont-family: 'NewsGothic';\n\tfont-size: 1.1em;\n\thyphens: auto; \n\ttext-align: justify;\n}\n\n .textNewsletter {\n  background: radial-gradient(\n    ellipse at center,\n    rgba(0, 181, 185, 1) 0%,\n    rgba(0, 181, 185, 1) 70%,\n    rgba(0, 181, 185, 0) 70.3%\n  );\n  height: 100%;\n  width: 100%;\n}\n.textNewsletter {\n  color: white;\n  position: relative;\n  margin: 0;\n}\n\n.textNewsletter p {\n  height: 100%;\n  line-height: 1.25;\n  padding: 0;\n  text-align: center;\n  text-shadow: 0.5px 0.5px 1px rgba(0, 0, 0, 0.3);\n}\n\n.textNewsletter::before {\n  content: \"\";\n  float: left;\n  height: 100%;\n  width: 50%;\n  shape-outside: polygon(\n    0 0,\n    98% 0,\n    50% 6%,\n    23.4% 17.3%,\n    6% 32.6%,\n    0 50%,\n    6% 65.6%,\n    23.4% 82.7%,\n    50% 94%,\n    98% 100%,\n    0 100%\n  );\n  shape-margin: 3%;\n}\n\n.textNewsletter p::before {\n  content: \"\";\n  float: right;\n  height: 100%;\n  width: 50%;\n  shape-outside: polygon(\n    2% 0%,\n    100% 0%,\n    100% 100%,\n    2% 100%,\n    50% 94%,\n    76.6% 82.7%,\n    94% 65.6%,\n    100% 50%,\n    94% 32.6%,\n    76.6% 17.3%,\n    50% 6%\n    );\n  shape-margin: 3%;\n}\n\n\n\n.modelhero .content {\n    align-items: center;\n    background-color: rgba(220,220,220,.8);\n    -webkit-clip-path: polygon(40% 0,100% 0,100% 100%,20% 100%);\n    clip-path: polygon(42% 0,100% 0,100% 100%,28% 100%);\n    display: flex;\n    height: 100%;\n    justify-content: flex-start;\n    max-width: 40rem;\n    padding: 2rem 4rem 2rem 15rem;\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n\n.modelhero .heading {\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    -ms-grid-row-align: flex-start;\n    align-items: flex-start;\n    padding-bottom: 0;\n}\n\n.modelhero .content h3 {\n    color: var(--white);\n    line-height: 1.3;\n    padding-bottom: 1rem;\n}\n\n.modelhero .content p {\n    color: var(--white);\n    letter-spacing: .5px;\n    line-height: 1.6;\n    padding-bottom: 2rem;\n}\n\n.modelhero .btn {\n    border: 0.15rem solid var(--white);\n}\n\n\n.MuiFormLabel-root {\n\tfont-size: 18px;\n}\n\n\n\n\n\n.about .box-container {\n    display: flex;\n    flex-wrap: wrap;\n    min-height: 80vh;\n    position: relative;\n    overflow: hidden;\n}\n\n.about img {\n    height: 80vh;\n    object-fit: cover;\n    width: 100%;\n}\n\n\n.about .content {\n    align-items: center;\n    background-color: rgba(220,220,220,.8);\n    -webkit-clip-path: polygon(40% 0,100% 0,100% 100%,20% 100%);\n    clip-path: polygon(42% 0,100% 0,100% 100%,28% 100%);\n    display: flex;\n    height: 100%;\n    justify-content: flex-start;\n    max-width: 40rem;\n    padding: 2rem 4rem 2rem 15rem;\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n\n.about .heading {\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    -ms-grid-row-align: flex-start;\n    align-items: flex-start;\n    padding-bottom: 0;\n}\n\n.about .content h3 {\n    color: var(--white);\n    line-height: 1.3;\n    padding-bottom: 1rem;\n}\n\n.about .content p {\n    color: var(--white);\n    letter-spacing: .5px;\n    line-height: 1.6;\n    padding-bottom: 2rem;\n}\n\n.about .btn {\n    border: 0.15rem solid var(--white);\n}\n\n\n\n.btn {\n    background: var(--main-color);\n    box-shadow: var(--box-shadow);\n    color: var(--white);\n    display: inline-block;\n    font-size: 1.8rem;\n    font-weight: 500;\n    letter-spacing: .1rem;\n    padding: 1rem 2.5rem;\n    transition: all .5s ease-in-out;\n}\n\n.galleryImg {\n    height:150px;\n    width:100%;\n }\n \n.galleryImgZoom {\n    animation:move 22s infinite ease-in-out;\n }\n\n@keyframes move{\n0%{\n transform: scale(1) rotate(0deg);\n}\n  100%{\n   transform: scale(1.2) rotate(0.1deg);\n\n  }\n\n}\n\n/* Slow-motion Zoom Container */\n.img-hover-zoom--slowmo img {\n  transform-origin: 50% 65%;\n  transition: transform 1s, filter 1s ease-in-out;\n}\n\n/* The Transformation */\n.img-hover-zoom--slowmo:hover img {\n  transform: scale(1.1);\n}\n\n.hover14 figure {\n\tposition: relative;\n}\n.hover14 figure::before {\n\tposition: absolute;\n\ttop: 0;\n\tleft: -75%;\n\tz-index: 2;\n\tdisplay: block;\n\tcontent: '';\n\twidth: 50%;\n\theight: 100%;\n\tbackground: -webkit-linear-gradient(left, rgba(255,255,255,0) 0%, rgba(255,255,255,.3) 100%);\n\tbackground: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,.3) 100%);\n\t-webkit-transform: skewX(-25deg);\n\ttransform: skewX(-25deg);\n}\n.hover14 figure:hover::before {\n\t-webkit-animation: shine .75s;\n\tanimation: shine .75s;\n}\n@-webkit-keyframes shine {\n\t100% {\n\t\tleft: 125%;\n\t}\n}\n@keyframes shine {\n\t100% {\n\t\tleft: 125%;\n\t}\n}\n\n\nfigure {\n\tmargin: 0;\n}\n\n.MuiTabs-vertical {\n\tmin-width: 200px;\n}\n\nh1,h2,h3,h4,h5,h6, a {\n\tcolor: rgba(0,0,0,0.6);\n\tfont-weight: 400;\n\t\n}\n\n/* Zoom In #1 */\n.hover01 figure img {\n\t-webkit-transform: scale(1);\n\ttransform: scale(1);\n\t-webkit-transition: .3s ease-in-out;\n\ttransition: .3s ease-in-out;\n}\n.hover01 figure:hover img {\n\t-webkit-transform: scale(1.3);\n\ttransform: scale(1.3);\n}\n\n/* Zoom In #2 */\n.hover02 figure img {\n\twidth: 300px;\n\theight: auto;\n\t-webkit-transition: .3s ease-in-out;\n\ttransition: .3s ease-in-out;\n}\n.hover02 figure:hover img {\n\twidth: 350px;\n}\n\n/* Zoom Out #1 */\n.hover03 figure img {\n\t-webkit-transform: scale(1.5);\n\ttransform: scale(1.5);\n\t-webkit-transition: .3s ease-in-out;\n\ttransition: .3s ease-in-out;\n}\n.hover03 figure:hover img {\n\t-webkit-transform: scale(1);\n\ttransform: scale(1);\n}\n\n/* Zoom Out #2 */\n.hover04 figure img {\n\twidth: 400px;\n\theight: auto;\n\t-webkit-transition: .3s ease-in-out;\n\ttransition: .3s ease-in-out;\n}\n.hover04 figure:hover img {\n\twidth: 300px;\n}\n\n/* Slide */\n.hover05 figure img {\n\tmargin-left: 30px;\n\t-webkit-transform: scale(1.5);\n\ttransform: scale(1.5);\n\t-webkit-transition: .3s ease-in-out;\n\ttransition: .3s ease-in-out;\n}\n.hover05 figure:hover img {\n\tmargin-left: 0;\n}\n\n@-webkit-keyframes flash {\n\t0% {\n\t\topacity: .4;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}\n@keyframes flash {\n\t0% {\n\t\topacity: .4;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}\n\n.backgroundColor1 {\n\tbackground: linear-gradient(135deg, rgba(91, 228, 155, 0.2), rgba(0, 167, 111, 0.2)) rgb(255, 255, 255);\t\n\tmin-height: 200px;\n}\n\n.backgroundColor2 {\n\tbackground: linear-gradient(135deg, rgba(97, 243, 243, 0.2), rgba(0, 184, 217, 0.2)) rgb(255, 255, 255);\t\n\tmin-height: 200px;\n}\n\n.backgroundColor3 {\n\tbackground: linear-gradient(135deg, rgba(255, 214, 102, 0.2), rgba(255, 171, 0, 0.2)) rgb(255, 255, 255);\t\n\tmin-height: 200px;\n}\n\n.backgroundColor3a {\n\tbackground: linear-gradient(135deg, rgba(255, 214, 102, 0.2), rgba(255, 171, 0, 0.2)) rgb(255, 255, 255);\t\n\tmax-height: 30px;\n}\n\n.bgIcon {\n    width: 112px;\n    height: 112px;\n    right: -32px;\n    opacity: 0.08;\n\tmargin-right: -25px;\n}\n\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.swiper-pagination {\n\tmargin-top: 10px;\t\n\tpadding-bottom: 5px;\t\n}\n\n.swiper-pagination-bullet {\n  width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 12px));\n  height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 12px));\n  display: inline-block;\n  border-radius: var(--swiper-pagination-bullet-border-radius, 50%);\n  background: var(--swiper-pagination-bullet-inactive-color, #000);\n  opacity: var(--swiper-pagination-bullet-inactive-opacity, 0.2);\n  font-size: 12px;\n  color: white;\n}\n\n.centerImage {\n  border: 1px solid;\n  margin: auto;\n  width: 75%;\n  padding: 10px;\n}\n\n.bottomRight {\n    position: fixed;\n    bottom: 0;\n    right: 0;\n}\n\n\n.MuiStepLabel-label {\n\tfont-size: 16px !important;\n}\n\n.leftSpacing {\n\tmargin-left: 20px;\t\n}\n\n.spacerHeader {\t\n\twidth: 100%;\n\tmargin-bottom: 40px;\n  \theight: 1px;\n\tbackground: linear-gradient(90deg, rgba(255,255,255,.5) 0%, rgba(100,100,100,.5) 50%, rgba(255,255,255,.5) 100%);\n}\n\n.spacer {\t\n\twidth: 90%;\n\tmargin-top: 40px;\n  \theight: 1px;\n\tbackground: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(100,100,100,.5) 50%, rgba(255,255,255,1) 100%);\n}\n\n\n \n \n\n.swiper-horizontal {\n\tborder-top: 0px solid #ddd;\t\n\tpadding-top: 15px;\n}\n\n.swiper-pagination {\n\tborder-bottom: none;\t\n}\n\n.centerCarCard {\n    width: 345px; \n    height: auto;\n    margin: 0 auto;\n    padding: 10px;\n    position: relative;\n}\n\n.displayHeight {\n    width: 305px; \n\theight: auto;\n    margin: 0 auto;\n    padding: 10px;\n    position: relative;\n}\n\n.smallHeader .smallHeader-image {\n  display: block;\n  visibility: hidden;\n  height: auto;\n  width: 100%;\n }\n \n.pulse:hover, \n.pulse:focus {\n  animation: pulse 1s;\n  box-shadow: 0 0 0 2em transparent;\n}\n\n@keyframes pulse {\n  0% { box-shadow: 0 0 0 0 var(--hover); }\n}\n \n \n\n\n.heroAdvice1 {\n\tposition: absolute;\n\tleft: 0px;\n\tright: 0px;\n\tz-index: 1000;\n\ttext-align: center;\n\tborder-radius: 5px;\n  display: grid;\n  justify-content: center;\n  align-items: center;\t\n}\n\n.heroAdvice {\n\tposition: absolute;\n\tmargin-top: 20px;\n\tmargin-left: 0px;\n\twidth: 100%;\n\tz-index: 1000;\n}\n\n.heroHeadline {\n\tcolor: #fff;\n\tfont-weight: 1000;  \n\tfont-size: 3em;\n}\n\n.heroSlogan {\n\tcolor: #fff;\n\tfont-weight: 800;  \n\tfont-size: 1.5em;\n}\n\n.slide-container .content {\n    align-items: center;\n    background: linear-gradient(rgba(0,0,0,.7),rgba(0,0,0,.3));\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    left: 0;\n    padding: 8rem 7% 2rem;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: 100;\n}\n\n.slide-container .content .text {\n    text-align: center;\n    width: 80rem;\n}\n \n.container img {\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n}\n\n.txtLeft {\n\ttext-align: left;\t\n\t\n}\n\nul.empty {\n    list-style-type: none;\n\tmargin: 0;  \n    padding: 0; \n    margin-top: 20px;\n}  \n\nul.empty > li > svg {\n\tmargin-right: 5px;\n}\n\nul.empty2 {\n    list-style-type: none;\n\tmargin: 0;  \n    padding: 0; \n    margin-top: 0px;\n    padding-bottom: 8px;\n}  \n\nul.empty2 > li > svg {\n\tmargin-right: 5px;\n}\n\nul.empty2 > li {\n\tdisplay: inline-flex;\n    list-style-type: none;\n\tmargin: 0;  \n    padding: 0; \n    margin-top: 0px;\n}  \n\nul.empty > li {\n\tdisplay: flex;\n    list-style-type: none;\n\tmargin: 0;  \n    padding: 0; \n    margin-top: 5px;\n}  \n\nul.empty2 > li {\n    margin-top: 0 !important;\n}  \n  \n.nav ul {\n    list-style: none;\n}\n\n.nav li {\n    display: inline-block !important;\n    padding: 0;\n    vertical-align: middle;\n}\n\n\n.headlineCompare {\n\tmargin: 0px;\n\tmargin-bottom: 4px;\n}\n\n.swiper-button-prev {\n\tcolor: #dc0000;\n}\n\n.swiper-button-next {\n\tcolor: #dc0000;\n}\n\n.swiperTopBottom > div  > .swiper-button-prev {\n\tleft: 50% !important;\n    top: 0 !important;\n    transform: rotate(90deg);\n    transform-origin: left center;\n}\n\n.swiperTopBottom > div > .swiper-button-next {\n \tleft: 50% !important;\n   \tbottom: 20px !important;\n\tposition: sticky;\n    transform: rotate(90deg);\n    transform-origin: left center;\n}\n\n\n.check .leftSpace {\n\tmargin-left: 0px;\n}\n\n.textOutline {\n\t  -webkit-text-stroke-width: 4px;\n  -webkit-text-stroke-color: red;\n}\n\na {\n\tcursor: pointer;\n}\n\nbody {\n\tfont-family:'NewsGothic'\n}\n\n@font-face {\n    font-family: 'NewsGothic';\n    font-style: normal;\n    font-weight: 400; /* Standard/Regular */\n    src: url('assets/fonts/NewsGot-Reg.woff2') format('woff2'),\n         url('assets/fonts/NewsGot-Reg.otf') format('opentype');\n    font-display: swap; /* Verhindert das \"Verschwinden\" des Textes beim Laden */\n}\n\n/* News Gothic - Demi-Bold (wird als Bold genutzt) */\n@font-face {\n    font-family: 'NewsGothicBold';\n    font-style: normal;\n    font-weight: 700; /* Bold-Äquivalent */\n    src: url('assets/fonts/NewsGot-Dem.woff2') format('woff2'),\n         url('assets/fonts/NewsGot-Dem.otf') format('opentype');\n    font-display: swap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
